import { render, staticRenderFns } from "./IncluirEmpresaDialog.vue?vue&type=template&id=27cefb34"
import script from "./IncluirEmpresaDialog.vue?vue&type=script&lang=js"
export * from "./IncluirEmpresaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports